import Vue from 'vue'
import Router from 'vue-router'
import {getToken} from "../utils/auth";

Vue.use(Router)
const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/index/index'),
      meta: {requireAuth: false}
    },
    {
      path: '/detail',
      name: 'Detail',
      component: () => import('@/views/index/detail'),
      meta: {requireAuth: false}
    },
    {
      path: '/register',
      name: '注册',
      component: () => import('@/views/auth/register'),
      meta: {requireLogin: true, requireAuth: false}
    },
    {
      path: '/login',
      name: '登录',
      component: () => import('@/views/auth/login'),
      meta: {requireLogin: true, requireAuth: false}
    },
    {
      path: '/reset-pwd',
      name: '重置密码',
      component: () => import('@/views/auth/reset-pwd'),
      meta: {requireLogin: true, requireAuth: false}
    },
    {
      path: '/user',
      name: 'User',
      component: () => import('@/views/user/index'),
      meta: {requireAuth: true}
    },
    {
      path: '/prop-detail',
      name: 'propDetail',
      component: () => import('@/views/user/prop-detail'),
      meta: {requireAuth: true}
    },
    // {
    //   path: '/user/role',
    //   name: 'Role',
    //   component: () => import('@/views/user/role'),
    //   meta: {requireAuth: true}
    // },
    // {
    //   path: '/user/prop',
    //   name: 'Prop',
    //   component: () => import('@/views/prop/index'),
    //   meta: {requireAuth: true}
    // },
    // {
    //   path: '/user/prop/detail',
    //   name: 'detail',
    //   component: () => import('@/views/prop/detail'),
    //   meta: {requireAuth: true}
    // },
  ]
})

// 路由判断登录 根据路由配置文件的参数
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requireAuth)){ // 判断该路由是否需要登录权限
    const hasToken = getToken()

    if (hasToken) { // 判断当前的token是否存在 ； 登录存入的token

        next();
    }
    else {
      next({
        path: '/login',
        query: {redirect: to.fullPath} // 将跳转的路由path作为参数，登录成功后跳转到该路由
      })
    }
  } else {
    next();
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js